import React from "react";
import _ from "lodash";
import AssetManager from "../../managers/AssetManager";
import TalkerFrame from "./TalkerFrame";
import StyleUtils from "../../utils/StyleUtils";
import WidgetConfig from "../../config/widget";
import AppConstants from "../../constants/AppConstants";
import GalleryConstants from "../../constants/GalleryConstants";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { DESIGN_CONTEXT } from "../../constants/DesignContextConstants";

export const getData = (props) => {
  const { content, elemProps, layout, theme } = props;
  const data = {
    layout,
    builder: true,
    config: {},
  };

  const galWidth = elemProps.get("w");

  const imgPad = elemProps.getIn(["gallery", "imgPad"], 0);
  const dots = elemProps.getIn(["gallery", "dots"], false);
  const noloop = elemProps.getIn(["gallery", "noloop"], false);
  const imgInactive = elemProps.getIn(["gallery", "imgInactive"], false);

  data.config.imgPad = imgPad;

  if (dots) {
    const dotInfo = dots.toJS();
    if (_.has(dotInfo, "c")) {
      dotInfo.c = StyleUtils.getColorValue(dotInfo.c, theme);
      dotInfo.ac = StyleUtils.getColorValue(dotInfo.ac, theme);
    }
    data.config.dots = dotInfo;
  }

  if (noloop) {
    data.config.wrap = false;
  }

  if (imgInactive) {
    data.config.imgInactive = imgInactive;
  }

  data.config.preload = elemProps.getIn(["gallery", "preload"], GalleryConstants.SLIDING_PRELOAD);

  const items = content.get("items", false);
  const type = content.getIn(["config", "type"], AppConstants.GALLERY_SLIDING_TYPE_FILMSTRIP);
  const imageSize = AssetManager.determineSize(galWidth);
  const images = [];
  const designContext = elemProps.get(DESIGN_CONTEXT);
  const { generateDesignAssetUrl } = DesignContextUtils.fromContext(designContext);

  items.forEach((image) => {
    const key = image.get("key");
    const op =
      key.endsWith(AppConstants.EXT_GIF) || key.endsWith(AppConstants.EXT_SVG) ? "file" : imageSize;
    const url = generateDesignAssetUrl({ key, op, provider: image.get("provider") });

    images.push({ u: url });
  });

  data.images = images;
  data.config.type = type;

  return data;
};

const GallerySlidingWidget = (props) => (
  <TalkerFrame data={getData(props)} src={WidgetConfig.slidingGallery.url} />
);

export default GallerySlidingWidget;
